<template>
    <div class="paginator__panel">
        <button @click="$emit('increase-count',countPage+5);active=1">Показать еще</button>
        <div class="paginator__buttons">
            <button @click="prev">
                <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 1L1 5L5 9" stroke="#0D3041" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <template v-for="item in page" :key="item.id">
                 <button v-if ="item!='...'" @click="$emit('change',(item-1)*countPage);active=item" :class="active==item?'paginator__button_active':''">{{item}}</button>
                 <span v-if ="item=='...'">{{item}}</span>
            </template>
           
            <button @click="next">
                <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 9L5 5L1 1" stroke="#0D3041" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        </div>
    </div>
</template>
<script>
export default{
    emits:['change','increase-count'], 
    computed:{
        page(){
            const count = Math.ceil(this.count/this.countPage)
            let arra = [];
            if (count > 4 && count-2 >= this.active){
                for (let i=this.active;this.active+2>i;i++){
                    arra.push(i);
                }
                arra.push('...');
                arra.push(count);
                
                return arra 
            }
            for (let i=this.active-2;this.active+2>i;i++){
                if (i<=count && i>0)
                    arra.push(i);
            }
            return arra 
        }
    },
    methods:{
        next(){
            if ((this.active)*this.countPage<this.count){
                this.active++
                this.$emit('change',(this.active-1)*this.countPage)
            }
        },
        prev(){
            if ((this.active-1)*this.countPage>0){
                this.active--
                this.$emit('change',(this.active-1)*this.countPage)
            }
        }
    },
    props:{
        count:{default:0},
        countPage:{default:0}
    },
    data(){
        return{
            active:1,
        }
    }
}
</script>
<style>
.paginator__panel{
    margin-top: 64px;
    margin-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap:32px;
    font-family: Rubik;
}
.paginator__panel button{
    box-sizing: border-box;
    border: solid 2px #0D3041;
    color: #0D3041;
    border-radius: 10px;
    background-color: var(--background);
    padding: 12px 24px;
    font-size: 14px;
    cursor: pointer;
}
.paginator__panel button:hover{
    background-color: #EDF6FF;
}
.paginator__panel button:active{
    background-color: #174E72;
    color: #fff;
}
.paginator__panel  .paginator__buttons span,
.paginator__panel .paginator__buttons button{
    cursor: default;
    border:none;
    padding: 0 16px 0 0 ;
    font-size: 16px;
}
.paginator__panel .paginator__buttons button:last-child{
    padding: 0;
}
.paginator__panel .paginator__buttons button:hover path,
.paginator__panel .paginator__buttons button:active path{
    stroke: #007BB8 !important;
    cursor: pointer;
}
.paginator__panel .paginator__buttons button:hover,
.paginator__panel .paginator__buttons button:active{
    background-color: transparent;
    color:#007BB8;
    cursor: pointer;

}
.paginator__panel .paginator__buttons button.paginator__button_active{
    color:#007BB8;      
}
</style>